import { ButtonDarkTheme } from './button.dark-theme';
import { ButtonStyleType } from './button.style-type';

export const ButtonLightTheme: ButtonStyleType = ButtonDarkTheme;
